<ng-container *ngIf="mobile">
	<app-mobile-sign-in>
	</app-mobile-sign-in>
</ng-container>
<ng-container *ngIf="!mobile">
	<app-web-sign-in>
	</app-web-sign-in>
</ng-container>
